export const leadGeneratorActionTypes = {
  GET_LEAD_GENERATOR_SUCCESS: undefined,
  GET_LEAD_GENERATOR: undefined,
  SAVE_LEAD_GENERATOR: undefined,
  LEAD_GENERATOR_SAVED: undefined,
};
